import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
//import { ModalResumenMediosVerificacionComponent } from '../../../dialogs/modal-resumen-medios-verificacion/modal-resumen-medios-verificacion.component';
import { NgxSpinnerService } from "ngx-spinner";
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ValidacionService } from 'src/app/service/validacion.service';
import Swal from 'sweetalert2';
import { StorageService } from 'src/app/service/storage.service';
import { JardinModel, ResponseJardinModel } from 'src/app/model/Jardin.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JardinValidacionExternaComponent } from '../../jardin-validacion-externa.component';
import { apiService } from 'src/app/service/api.service';
import { ModalConfirmarEliminacionComponent } from '../../../dialogs/modal-confirmar-eliminacion/modal-confirmar-eliminacion.component';
import { ModalAutoevaluacionMediosVerificacionComponent } from '../../../dialogs/modal-autoevaluacion-medios-verificacion/modal-autoevaluacion-medios-verificacion.component';

@Component({
  selector: 'app-apelacion-jardin',
  templateUrl: './apelacion-jardin.component.html',
  styleUrls: ['./apelacion-jardin.component.css']
})
export class ApelacionJardinComponent implements OnInit {
  @Input() simulacion: boolean;
  @ViewChild('modalDecripcion') modalDecripcion:ElementRef;
  @ViewChild('modalObservaciones') modalObservaciones: TemplateRef<any>;
  
  public autoEvaluacion = [];

  finalizarAutoEvaluacion = true;
  numTabSelected : number;

  jardin: JardinModel;
  one: boolean = false;
  modelReference: any;
  valorRecibido;
  valorGuardar;
  actaEntregada: boolean = false;
  elentosApelados:number;
  jardinPeriodoInforme:any;

  constructor(
    @Inject(JardinValidacionExternaComponent) private parent: JardinValidacionExternaComponent,
    private api: apiService,
    private validacionService: ValidacionService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public storageService: StorageService,
    private _snackBar: MatSnackBar,
    private modal: NgbModal,
    private changeRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.numTabSelected = 0;
    this.spinner.show();
    this.getJardinPeriodoInforme();
    this.obtenerAutoevaluacion();
  }


  getJardinPeriodoInforme(){
    const param = this.api.dataJardin.idJardinPeriodo;
    this.validacionService.API_POST_getDataInformeValidacion(param).subscribe(result => {

      if(this.jardinPeriodoInforme.fechaVistaInformeRestultados != null){
        let fecha = new Date(this.jardinPeriodoInforme.fechaVistaInformeRestultados);
        fecha.setTime( fecha.getTime() + fecha.getTimezoneOffset()*60*1000 );
        this.jardinPeriodoInforme.fechaVistaInformeRestultados = fecha;
      }
      if(this.jardinPeriodoInforme.fechaLimiteApelacion != null){
        let fecha = new Date(this.jardinPeriodoInforme.fechaLimiteApelacion);
        fecha.setTime( fecha.getTime() + fecha.getTimezoneOffset()*60*1000 );
        this.jardinPeriodoInforme.fechaLimiteApelacion = fecha;
      }

    }, (err) => {
      console.log(err);
    });
  }

  obtenerAutoevaluacion(){
  
    this.api.API_POST_getApelacionJardin().subscribe((response: any) => {
      this.autoEvaluacion = response.payload;
      this.autoEvaluacion.splice(5,1)
      this.validarEstadosAutoevaluacion();
      this.spinner.hide();
    },
    (err) => {
      console.log(err)
    })     
  }

  guardarAvances(){
    this.openSnackBarSuccess();
  }


  validarEstadosAutoevaluacion(){
    this.changeRef.detectChanges();
    this.elentosApelados = 0;
    this.autoEvaluacion.forEach((area)=>{
      area.dimensiones.forEach((dimension)=>{
        var areaFinalizada:number = 0;
        dimension.elementos.forEach((pregunta:any)=>{
          var observacion: String = pregunta.observacionApelacion;
          if(pregunta.apela && observacion.trim().length > 0){
            this.elentosApelados ++;
            areaFinalizada++;
          }  
        });
        dimension.finalizado = areaFinalizada > 0 ? 2 : null
      });
    });
  }



  validaEvaluacionMedios(pregunta){
    var completo : boolean = true;
    pregunta.vinculados.forEach((vinculado:any)=>{
      if (((vinculado.validador1t != vinculado.validador2t) ) ||
        ((vinculado.validador1c != vinculado.validador2c) ) ||
        ((vinculado.validador1p != vinculado.validador2p) )){
          completo = false;
      }  else if(!this.validarNulo(vinculado)){
        completo = false;
      }
    });
    return completo;
  }

  validaEvaluacionMediosVirtuales(pregunta){
    var completo : boolean = true;  
    pregunta.vinculadosVirtual.forEach((vinculadoVirtual:any)=>{
        if (((vinculadoVirtual.validador1t != vinculadoVirtual.validador2t) ) ||
          ((vinculadoVirtual.validador1c != vinculadoVirtual.validador2c) ) ||
          ((vinculadoVirtual.validador1p != vinculadoVirtual.validador2p) ) ){
            completo = false;
        }else if(!this.validarNulo(vinculadoVirtual)){
          completo = false;
        }
    });
    return completo;
  }

  validarNulo(vinculadoVirtual){
    return (vinculadoVirtual.validador1t === true || vinculadoVirtual.validador1t === false) &&
    (vinculadoVirtual.validador1c === true || vinculadoVirtual.validador1c === false) &&
    (vinculadoVirtual.validador1p === true || vinculadoVirtual.validador1p === false);
  }
  

  descargarMedio(id){
    console.log(id)
    this.api.API_POST_descargarMediosVerificacion(id).subscribe((response) => {
      var save = document.createElement('a');   
      save.href = "data:"+response.payload.mime+";base64,"+response.payload.base
      save.target = '_blank';
      save.download = response.payload.nombre || 'archivo.dat';
      var clicEvent = new MouseEvent('click', {
          'view': window,
              'bubbles': true,
              'cancelable': true
      });
      save.dispatchEvent(clicEvent);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    },
    (err) => {
      console.log(err)
    })
  }



  finalizar(){
    Swal.fire({
      title: 'Finalizar y Enviar Apelación',
      html: "¿Está seguro/a que desea finalizar y Enviar su Apelación? <br><br> Al realizar esta acción los datos no podrán ser modificados.",
      icon: 'info',
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Enviar Apelación',
    }).then((result) => {
      if (result.isConfirmed) {
          this.spinner.show();
          const param = this.api.dataJardin.idJardinPeriodo
          this.validacionService.API_POST_finalizarApelacion(param).subscribe((response: any) => {
            this.spinner.hide();
            this.volver();
          },
          (err) => {
            this.spinner.hide();
            console.log("error"+err)
          })
      } 
    })
  }



  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.numTabSelected = tabChangeEvent.index;
  }

  desc(data) {
    this.valorGuardar = data.descripcionPractica;
    this.valorRecibido = data
    this.modelReference = this.modal.open(this.modalDecripcion,{ size: 'sm'} ); 
  }



  openSnackBarSuccess() {
    this._snackBar.open('Se Guardó correctamente', 'Cerrar', {
      horizontalPosition: "end",
      verticalPosition: "top",
      duration:6000
    });
  }

  openSnackBarError() {
    this._snackBar.open('Error al Guardar', 'Cerrar', {
      horizontalPosition: "end",
      verticalPosition: "top",
      duration:6000
    });
  }



  volver(){
    this.parent.ngOnInit();
  }


  updateElemento(elemento){
    console.log(elemento);
    if(!elemento.apela){
      elemento.observacionApelacion = "";
    }
    this.spinner.show();
    this.api.API_POST_guardarElementoApelacion(elemento).subscribe((response: any) => {
      this.validarEstadosAutoevaluacion();
      this.spinner.hide();
      this.openSnackBarSuccess();
    },
    (err) => {
      this.spinner.hide();
      this.openSnackBarError();
      console.log(err)
    })  
  }

}